<template>
  <div class="scene-module scene-company">
    <v-drop-down-menu
      v-if="$store.state.sceneClassName === 'app'"
      :menu="menu"
      className="app-company-nav"
    ></v-drop-down-menu>
    <div v-else id="navFooter" class="nav-footer">
      <div class="nav-footer__content">
        <div class="nav-footer__left">
          企业培训
          <span class="line">|</span>
          <a class="EC1" href="/" target="_blank"
            >企业微信版 <i class="iconfont iconskip_icon"></i>
          </a>
        </div>
        <div class="nav-footer__list">
          <router-link
            to="/scene/company"
            class="nav-footer__item nav-footer__item-selected"
          >
            概览
          </router-link>
          <router-link to="/scene/price" class="nav-footer__item">
            价格
          </router-link>
        </div>
      </div>
    </div>
    <div class="corporate-banner-wrapper">
      <div class="corporate-banner-area w1200">
        <h1>企业培训</h1>
        <p>解决企业内外培训管理难题</p>
        <a href="/">立即创建体验</a>
      </div>
    </div>
    <div class="situation pt96 pb96">
      <div class="lz-title1 mb64">
        无需下载任何终端，微信和<br
          v-if="$store.state.sceneClassName === 'app'"
        />企业微信里就能直接培训
      </div>
      <div class="situation-content w1200">
        <div class="situation-content-item">
          <img
            v-if="$store.state.sceneClassName === 'app'"
            :src="require('@/assets/images/scenePic10_app.png')"
            alt=""
          />
          <img v-else :src="require('@/assets/images/scenePic10.png')" alt="" />
        </div>
        <div class="situation-content-item">
          <img
            v-if="$store.state.sceneClassName === 'app'"
            :src="require('@/assets/images/scenePic11_app.png')"
            alt=""
          />
          <img v-else :src="require('@/assets/images/scenePic11.png')" alt="" />
        </div>
      </div>
    </div>
    <div class="lz-modules1 module-lists pt96 pb48">
      <div class="lz-title1">
        兼顾组织管理与培训效果，<br
          v-if="$store.state.sceneClassName === 'app'"
        />快速打造学习型组织
      </div>
      <div v-if="$store.state.sceneClassName === 'app'"></div>
      <div>
        <div class="module-box w1200 pt96 pb96 row-reverse">
          <div class="module-text">
            <div class="title EC2 mb24 T4">一键导入组织成员名单</div>
            <div class="module-text-item mb16">
              <div class="desc EC3 T6">
                一键导入企业组织成员，快捷设置人员姓名、联系方式、岗位等信息。支持分组设置培训权限。
              </div>
            </div>
          </div>
          <div class="module-img">
            <img :src="require('@/assets/images/scenePic12.png')" alt="" />
          </div>
        </div>
      </div>
      <div class="row-reverse-bg">
        <div class="module-box w1200 pt96 pb96">
          <div class="module-text">
            <div class="title EC2 mb24 T4">实时直播培训与培训内容沉淀</div>
            <div class="module-text-item mb16">
              <div class="desc EC3 T6">
                支持用图文、音频、视频等形式进行实时直播培训，培训内容自动沉淀为单节课或专栏课，方便后续培训学习。
              </div>
            </div>
          </div>
          <div class="module-img">
            <img :src="require('@/assets/images/scenePic13.png')" alt="" />
          </div>
        </div>
      </div>

      <div>
        <div class="module-box w1200 pt96 pb96 row-reverse">
          <div class="module-text">
            <div class="title EC2 mb24 T4">考练工具提升培训效果</div>
            <div class="module-text-item mb16">
              <div class="desc EC3 T6">
                题库、练习、考试、随堂检测等工具帮助学员巩固培训知识，方便提升学习效果。
              </div>
            </div>
          </div>
          <div class="module-img">
            <img :src="require('@/assets/images/scenePic14.png')" alt="" />
          </div>
        </div>
      </div>

      <div class="row-reverse-bg">
        <div class="module-box w1200 pt96 pb96">
          <div class="module-text">
            <div class="title EC2 mb24 T4">可视化的培训数据结果</div>
            <div class="module-text-item mb16">
              <div class="desc EC3 T6">
                直观分析学员学习时长、课程数、考试分数等数据结果，快速掌握整体学习情况。
              </div>
            </div>
          </div>
          <div class="module-img">
            <img :src="require('@/assets/images/scenePic15.png')" alt="" />
          </div>
        </div>
      </div>

      <div>
        <div class="module-box w1200 pt96 pb96 row-reverse">
          <div class="module-text">
            <div class="title EC2 mb24 T4">企业知识库赋能一线业务</div>
            <div class="module-text-item mb16">
              <div class="desc EC3 T6">
                完成企业员工和伙伴的学习培训，用企业知识库帮助一线人员提升战斗力。
              </div>
            </div>
          </div>
          <div class="module-img">
            <img :src="require('@/assets/images/scenePic16.png')" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="module-func pt96 pb96">
      <div class="lz-title1 mb64">丰富的功能组合，贴合企业真实使用场景</div>
      <div class="func-content w1200">
        <div class="func-content-item">
          <img :src="require('@/assets/images/scenePic17.png')" alt="" />
          <p>员工培训</p>
          <div class="func-content-desc">
            <span>图文课<br />随堂检测</span>
            <span>音频课<br />每日打卡</span>
            <span>直播课<br />7天训练营</span>
          </div>
        </div>

        <div class="func-content-item">
          <img :src="require('@/assets/images/scenePic18.png')" alt="" />
          <p>加盟商、合作伙伴培训</p>
          <div class="func-content-desc">
            <span>直播课<br />课件共享</span>
            <span>专栏课<br />课后考试</span>
            <span>录制回看<br />荣誉证书</span>
          </div>
        </div>

        <div class="func-content-item">
          <img :src="require('@/assets/images/scenePic19.png')" alt="" />
          <p>远程客户实时交付</p>
          <div class="func-content-desc">
            <span>互动直播<br />题库练习</span>
            <span>电子白板<br />考试检测</span>
            <span>桌面共享<br />结业证书</span>
          </div>
        </div>
      </div>
    </div>
    <div class="pt96 pb96 bg-module">
      <div class="lz-title1 mb64">满足不同行业的企业培训场景需求</div>
      <div class="industry-item">
        <img
          v-if="$store.state.sceneClassName === 'app'"
          :src="require('@/assets/images/scenePic20_app.png')"
          alt=""
        />
        <img v-else :src="require('@/assets/images/scenePic20.png')" alt="" />
      </div>
    </div>
    <div v-if="$store.state.sceneClassName === 'app'" class="user-swiper">
      <div class="lz-title1">他们都在用知链<br />线上高效企业培训</div>
      <swiper :options="swiperOptionsApp">
        <swiper-slide class="demo" v-for="(item, index) in 4" :key="index">
          <img
            class="user-demo-img"
            :src="require('@/assets/images/scenePic21.png')"
          />
          <div class="user-demo-describe">
            <div class="user-demo-tips">
              运发私塾用知链解决员工集中培训难题
            </div>
            <div class="user-demo-describe-content">
              运发私塾通过知链，将培训从线下转移到线上。
            </div>
            <div class="user-demo-describe-content">
              可以让每天新入职员工及时获得培训资源，不用再集中培训了，少量讲师即可完成以往线下培训的全部任务量，人效得到极大提升。
            </div>
            <div class="user-use-tools">
              <div class="tools-tips">他们使用这些功能：</div>
              <div class="tools-list">
                <button class="tools-item" disabled="">视频课</button>
                <button class="tools-item" disabled="">图文课</button>
                <button class="tools-item" disabled="">音频课</button>
                <button class="tools-item" disabled="">考试</button>
                <button class="tools-item" disabled="">证书</button>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div v-else class="mt96 mb96">
      <div class="swiper-box">
        <img
          class="demo-area-left-bottom-bg-img"
          :src="require('@/assets/images/circle1.png')"
          alt=""
        />
        <img
          class="demo-area-right-top-bg-img"
          :src="require('@/assets/images/circle2.png')"
          alt=""
        />
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(item, index) in 4" :key="index">
            <div class="user-demo-area">
              <img
                class="user-demo-img"
                :src="require('@/assets/images/scenePic21.png')"
                alt=""
              />
              <div class="user-demo-describe">
                <div class="user-demo-tips">
                  运发私塾用知链解决员工集中培训难题
                </div>
                <div class="user-demo-describe-content">
                  运发私塾通过知链，将培训从线下转移到线上。
                </div>
                <div class="user-demo-describe-content">
                  可以让每天新入职员工及时获得培训资源，不用再集中培训了，少量讲师即可完成以往线下培训的全部任务量，人效得到极大提升。
                </div>
                <div class="user-use-tools">
                  <div class="tools-tips">他们使用这些功能：</div>
                  <div class="tools-list">
                    <button class="tools-item" disabled="">视频课</button>
                    <button class="tools-item" disabled="">图文课</button>
                    <button class="tools-item" disabled="">音频课</button>
                    <button class="tools-item" disabled="">考试</button>
                    <button class="tools-item" disabled="">证书</button>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-btn">
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
    </div>
    <v-free
      title="现在创建店铺，体验更实用的企业培训解决方案"
      desc="专业客户经理解答指引 贴心解决您的问题"
      href=""
    ></v-free>
  </div>
</template>

<script>
import DropDownMenu from '@/components/DropDownMenu';
import Free from '@/components/Free';
import SwiperCore, { Navigation, Autoplay, Lazy } from 'swiper';
SwiperCore.use([Navigation, Autoplay, Lazy]);
export default {
  data() {
    return {
      menu: [{
        id: 1,
        title: '概览',
        showText: '企业培训',
        link: '/scene/company'
      }, {
        id: 2,
        title: '价格',
        showText: '企学院',
        link: '/scene/price'
      }],
      swiperOptionsApp: {
        autoplay: {
          delay: 3000
        },
        speed: 1500,
        loop: true,
        lazy: {
          lazyLoadingOnTransitionStart: true
        }
      },
      swiperOptions: {
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true,
        speed: 1000,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    };
  },
  components: {
    'v-free': Free,
    'v-drop-down-menu': DropDownMenu
  }
};
</script>

<style lang="scss">
.scene-company {
  padding-top: 72px;
  .corporate-banner-wrapper {
    position: relative;
    padding-top: 218px;
    height: 640px;
    width: 100%;
    color: #fff;
    background-color: #1472ff;
    background-image: url('~@/assets/images/sceneBanner3.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 640px;
    .corporate-banner-area {
      h1 {
        margin-bottom: 32px;
        font-size: 64px;
        line-height: 72px;
        font-weight: 600;
      }
      p {
        margin-bottom: 72px;
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
        width: 400px;
      }
      a {
        display: block;
        width: 144px;
        height: 44px;
        line-height: 44px;
        background: #fff;
        border-radius: 22px;
        color: #1472ff;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
  .module-func .func-content .func-content-item + .func-content-item,
  .situation-content .situation-content-item + .situation-content-item {
    margin-left: 32px;
  }
  .situation-content {
    display: flex;
    justify-content: space-around;
  }
  .situation-content .situation-content-item {
    width: 568px;
    height: 568px;
    box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.08);
  }
  .situation-content .situation-content-item img {
    width: 100%;
    height: 100%;
  }
  .row-reverse-bg {
    background-color: rgba(20, 114, 255, 0.04);
  }
  .module-box {
    text-align: left;
    .title {
      font-weight: normal;
    }
    .module-img img {
      width: 668px;
    }
    .module-text-item {
      width: 468px;
    }
  }
  .module-func .func-content {
    display: flex;
    justify-content: center;
  }
  .module-func .func-content .func-content-item {
    padding: 24px 32px;
    width: 368px;
    height: 276px;
    box-sizing: border-box;
    text-align: center;
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.04), 0 0 20px 0 rgba(0, 0, 0, 0.03);
  }
  .module-func .func-content .func-content-item img {
    width: 180px;
    height: 112px;
  }
  .module-func .func-content .func-content-item p {
    padding-top: 16px;
    padding-bottom: 12px;
    line-height: 28px;
    font-size: 20px;
    font-weight: 500;
  }
  .module-func .func-content .func-content-item .func-content-desc {
    display: flex;
    justify-content: space-between;
  }
  .module-func .func-content .func-content-item .func-content-desc span {
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
  }
  .industry-item {
    height: 372px;
    text-align: center;
    img {
      margin: 0 auto;
      width: 1168px;
    }
  }
  .bg-module {
    background-color: rgba(20, 114, 255, 0.04);
  }
  .swiper-box {
    position: relative;
    width: 1168px;
    height: 488px;
    margin: 0 auto;
    .swiper-button-prev:after,
    .swiper-button-next:after {
      font-size: 18px;
      color: #333;
      font-weight: bold;
    }
  }

  .user-demo-area {
    display: flex;
    flex-direction: row;
    height: 488px;
    width: 1168px;
    background: rgba(20, 114, 255, 0.04);
    border-radius: 12px;
    padding-left: 100px;
    padding-top: 44px;
    position: relative;
    z-index: 1;
  }
  .user-demo-area .user-demo-img {
    width: 400px;
    height: 400px;
    margin-right: 100px;
    position: relative;
    z-index: 3;
  }
  .user-demo-area .user-demo-describe .user-demo-tips {
    margin-bottom: 16px;
    width: 500px;
    height: 34px;
    font-size: 24px;
    font-weight: 500;
    color: #333;
  }
  .user-demo-area .user-demo-describe .user-demo-describe-content {
    width: 500px;
    line-height: 40px;
    font-size: 20px;
    font-weight: 400;
    color: #333;
  }
  .user-demo-area .user-demo-describe .user-use-tools {
    position: absolute;
    bottom: 44px;
  }
  .user-demo-area .user-demo-describe .user-use-tools .tools-tips {
    width: 162px;
    height: 25px;
    font-size: 18px;
    font-weight: 400;
    color: #333;
  }
  .user-demo-area .user-demo-describe .user-use-tools .tools-list {
    margin-top: 16px;
  }
  .user-demo-area .user-demo-describe .user-use-tools .tools-list .tools-item {
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #1472ff;
    font-size: 16px;
    font-weight: 400;
    color: #1472ff;
    text-align: center;
    background-color: rgba(255, 255, 255, 0);
    margin: 0 6px;
  }
  .free-title {
    font-size: 36px !important;
    line-height: 52px;
  }
  .demo-area-left-bottom-bg-img {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2;
  }
  .demo-area-right-top-bg-img {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
  }
}
.app .scene-company {
  padding-top: 1.04rem;
  .app-company-nav {
    position: fixed;
    top: 1.04rem;
    left: 0;
    width: 100%;
    z-index: 8;
  }
  .corporate-banner-wrapper {
    padding-top: 1.44rem;
    height: 8.64rem;
    background-repeat: no-repeat;
    background-position: center;
    background-position-y: -0.96rem;
    background-image: url('~@/assets/images/sceneBanner3_app.png');
    background-size: cover;
    .corporate-banner-area {
      text-align: center;
      h1 {
        line-height: 1.3;
        font-size: 0.8rem;
        font-weight: 500;
        letter-spacing: 0.04rem;
        padding: 0.16rem 0 0.38rem;
        margin: 0;
      }
      p {
        margin: 0;
        font-size: 0.28rem;
        line-height: 1.3;
        width: 100%;
      }
      a {
        margin-top: 0.48rem;
        width: auto;
        height: auto;
        padding: 0.14rem 0.64rem;
        border: 0.02rem solid #fff;
        font-size: 0.28rem;
        border-radius: 0.44rem;
        background: #fff;
        display: inline-block;
        text-align: center;
        color: #1472ff;
      }
    }
  }
  .situation {
    padding-top: 1.28rem;
    padding-bottom: 0;
    .lz-title1 {
      margin-bottom: 0.96rem;
      font-size: 0.56rem;
      font-weight: 500;
    }
  }
  .situation-content {
    display: block;
    .situation-content-item {
      width: auto;
      height: auto;
      margin-top: 0.48rem;
      margin-left: 0;
      padding-left: 0.32rem;
      padding-right: 0.32rem;
      text-align: center;
      box-shadow: none;
      &:nth-of-type(1) {
        margin-top: 0;
      }
      img {
        width: auto;
        max-width: 100%;
        height: auto;
        box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.08);
      }
    }
  }
  .lz-title1 {
    font-size: 0.56rem;
    font-weight: 500;
  }
  .module-lists {
    padding-top: 1.28rem;
    .module-box {
      background-color: transparent;
      .module-text-item {
        width: auto;
        margin-bottom: 0.96rem;
      }
      .module-img img {
        width: 100%;
        height: auto;
      }
      .title {
        margin-bottom: 0.32rem;
      }
    }
    .module-text {
      text-align: left;
    }
  }
  .module-func {
    padding: 1.28rem 0.32rem;
    .func-content {
      display: block;
      .func-content-item {
        border-radius: 0.16rem;
        padding: 0.48rem 0.32rem;
        height: 5.52rem;
        &:not(:first-child) {
          margin: 0.8rem 0 0;
        }
      }
    }
  }
  .bg-module {
    padding: 1.28rem 0.32rem;
    .industry-item {
      height: auto;
      img {
        width: 100%;
      }
    }
  }
  .user-swiper {
    padding-top: 1.28rem;
    padding-bottom: 1.28rem;
    .demo {
      padding-left: 0.32rem;
      padding-right: 0.32rem;
      text-align: left;
      .user-demo-img {
        width: 100%;
      }
      .user-demo-tips {
        padding-top: 0.32rem;
        padding-bottom: 0.32rem;
        font-size: 0.32rem;
        font-weight: 500;
      }
      .user-demo-describe-content {
        line-height: 0.44rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #666;
      }
      .tools-tips {
        padding-top: 0.32rem;
        padding-bottom: 0.16rem;
        line-height: 0.44rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #666;
      }
      .tools-item {
        margin-right: 0.16rem;
        padding: 0.08rem;
        border-radius: 0.04rem;
        border: 0.02rem solid #1472ff;
        color: #1472ff;
        font-size: 0.24rem;
        background-color: rgba(255, 255, 255, 0);
      }
    }
  }
  .free {
    .free-title {
      font-size: 0.56rem !important;
    }
  }
}
</style>
